import AppBarComponent from '../../appBar/AppBarComponent';
import FooterComponent from '../../../FooterComponent';
import { ReactNode } from 'react';
import { useStyles } from './useStyles';
import { TTopicPathState } from '../../../topicPath/type/Type';

type BasePageLayoutWrapperProps = {
  children: ReactNode;
  patternName?: string;
  patternState?: TTopicPathState;
};

const BasePageLayoutWrapper = ({
  children,
  patternName,
  patternState
}: BasePageLayoutWrapperProps) => {
  const classes = useStyles();

  return (
    <div className={classes.MainWrapper}>
      <AppBarComponent patternName={patternName} patternState={patternState} />

      <main>{children}</main>

      <div className={classes.FooterConponent}>
        <FooterComponent />
      </div>
    </div>
  );
};

export default BasePageLayoutWrapper;
